import configBackground from '../wob-background-menu'
import WidgetConfigMenu from '../widget-config-menu'
import ConfigUrl from './config-url'
import appDisplay from 'scoreboard/components/app-display'
import i18n from 'scoreboard/components/i18n'
import ConfigWidgetLabel from 'scoreboard/dashboards/widgets/config-widget-label'

const EmbeddedContentConfig = WidgetConfigMenu.extend({
	typeSpecificTargets: function (hasTemplate) {
		let target = []

		target.push({
			type: 'dialog',
			label: i18n.get('dashboards.embeddedContent.editUrl'),
			target: (e) => {
				let view = new ConfigUrl({
					model: this.model,
					dialogTitle: 'dashboards.embeddedContent.editUrl'
				})

				appDisplay.dialog(view)

				e.preventDefault()
				e.stopPropagation()

				this.trigger('done')
			}
		})

		target.push({
			type: 'dialog',
			label: 'dashboards.setTitle',
			target: e => {
				e.preventDefault()

				let configView = new ConfigLabel({
					model: this.model
				})

				appDisplay.dialog(configView)

				this.trigger('done')
			}
		})

		target.push(configBackground(this.model.properties))

		return target
	}
})

/**
 * View for editing an embedded content widget's label
 */
const ConfigLabel = ConfigWidgetLabel.extend({
	dialogTitle: 'dashboards.setTitle',

	_getModelLabel: function () {
		return this.model.properties.get('label')
	},

	_setModelLabel: function (label) {
		this.model.properties.set('label', label)
	},

	_getSuggestion: function () {
		// We can't read from the iframe, so there's really nothing we can suggest
		return ''
	}
})

export default EmbeddedContentConfig

EmbeddedContentConfig.__filename__ = 'dashboards/widgets/embedded-content/embedded-content-config.js'
